import { useEffect, useState } from 'react';
import { GlobalStyles } from './styles/globalstyles'
import { BiPhoneCall } from 'react-icons/bi';
import { FaWhatsapp } from 'react-icons/fa';

import {
  Container,
  Header,
  Logo,
  Main,
  FirstTitle,
  SecondTitle,
  Subtitle,
  DivButton,
  DivIcons,
  DivLogo,
  TitleLogo,
  SubTitleLogo,
  SectionFooter,
  CopyRight,
  InfoCompany,
  TitleInfoCompany,
  ContactCompany,
  ContainerContactCompany,
  ContainerLogoFooter,
  DivLogoFooter,
  LogoFooter,
  TitleLogoFooter,
  SubTitleLogoFooter,
  ContainerTextLogo,
  SectionAbout,
  ContainerTextAbout,
  Navigation,
  MobileMenuButton,
  HeroText,
  FooterMapCard
} from './styles/styles'

import Icon from './components/Icon';
import Button from './components/Button';
import GalleryReact from './components/TabMenu/GalleryReact';
import FloatingButtonWhatsApp from './components/FloatingButtonWhatsApp';
import { buildWhatsAppLink } from './utils/whatsapp';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const whatsappHref = buildWhatsAppLink();
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevState) => !prevState);
  };
  const handleNavigationClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <GlobalStyles />
      <Container id="home">
        <Header>
          <DivLogo>
            <Logo />
            <ContainerTextLogo>
              <TitleLogo>EXTINCENTER</TitleLogo>
              <SubTitleLogo>
                Comercio e recarga de extintores
              </SubTitleLogo>
              <SubTitleLogo>
                Equipamentos e Recarga de Combate a Incêndio
              </SubTitleLogo>
            </ContainerTextLogo>
          </DivLogo>

          <MobileMenuButton
            type="button"
            $isOpen={isMobileMenuOpen}
            aria-label={isMobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="main-navigation"
            onClick={toggleMobileMenu}
          >
            <span />
            <span />
            <span />
          </MobileMenuButton>

          <Navigation id="main-navigation" $isOpen={isMobileMenuOpen}>
            <a href="#home" onClick={handleNavigationClick}>Home</a>
            <a href="#produtos" onClick={handleNavigationClick}>Serviços</a>
            <a href="#produtos" onClick={handleNavigationClick}>Produtos</a>
            <a href="#sobre" onClick={handleNavigationClick}>Sobre Nós</a>
            <a href="#contato" onClick={handleNavigationClick}>Contato</a>
          </Navigation>
        </Header>

        <Main>
          <HeroText>
            <FirstTitle>Qualidade, Preço justo e atendimento de qualidade</FirstTitle>

            <SecondTitle>
              <span>Sua segurança</span>
              <span>em boas mãos</span>
            </SecondTitle>

            <Subtitle>Não deixe sua empresa exposta a riscos desnecessários. Nossos extintores de incêndio estão sempre disponíveis para manutenção e recarga para garantir que estejam sempre prontos para uso.
            </Subtitle>
            <DivButton>
              <Button text="PEDIR UM ORÇAMENTO" fullWidth />
            </DivButton>
          </HeroText>
        </Main>

        <DivIcons
          whileInView="visible"
          initial="initial"
          viewport={{ once: true }}
          variants={{
            initial: { opacity: 0, y: 10 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { duration: 1, delay: 0.3 },
            },
          }}
        >
          <Icon src="/images/icons-just-price.svg" txt="Temos preço justo" alt="Rocket" />

          <Icon src="/images/icon-support-agent.svg" txt="Ótimo atendimento" alt="Flag" />

          <Icon src="/images/icon-atendente.svg" txt="Atendemos indústrias, empresas, comércios, condomínios entre outros " alt="Telescope" />
          
          <Icon src="/images/icon-engineering.svg" txt="Experiência no ramo e profissionais qualificados" alt="Telescope" />

        </DivIcons>
      </Container>
      <FloatingButtonWhatsApp />
      <SectionAbout
         id="sobre"
         whileInView="visible"
         initial="initial"
         viewport={{ once: true }}
         variants={{
           initial: { opacity: 0, y: 10 },
           visible: {
             opacity: 1,
             y: 0,
             transition: { duration: 1, delay: 0.3 },
           },
         }}
      >
          <img src="/images/company/extincenter-fachada.webp" alt="Fachada extincenter" ></img>
        <ContainerTextAbout>
          <h1 className='titleAbout'>QUEM SOMOS ?</h1>
          <h1>Somos referência quando se trata de extintores e prevenção contra incêndio no estado de Mato Grosso.</h1>
          <p>Somos uma empresa com mais de 20 anos no mercado com vasta experiência em combate a incêndio.
            Temos tudo o que você precisa para combate a incêndio. Nosso diferencial está em agilidade no atendimento, contando com técnicos especializados e treinados.
            A Extincenter Extintores oferece o que há de melhor, com técnicos e profissionais capacitados, desde recargas de extintores até manutenção e instalação do sistema de combate a incêndio.
          </p>
        </ContainerTextAbout>
      </SectionAbout>
      <GalleryReact />

      <SectionFooter id="contato">
        <ContainerLogoFooter>
          <DivLogoFooter>
            <LogoFooter />
          </DivLogoFooter>
          <ContainerTextLogo>
            <TitleLogoFooter>EXTINCENTER</TitleLogoFooter>
            <SubTitleLogoFooter>
              Comercio e recarga de extintores
            </SubTitleLogoFooter>
            <SubTitleLogoFooter>
              Equipamentos e Recarga de Combate a Incêndio
            </SubTitleLogoFooter>
          </ContainerTextLogo>
        </ContainerLogoFooter>
        <InfoCompany>
          <ContainerContactCompany>
            <TitleInfoCompany>Endereço</TitleInfoCompany>
              <strong>Extincenter Extintores</strong>  
              <span>R. São Bento, 21 - Centro Norte, Várzea Grande - MT, 78110-650</span>
          </ContainerContactCompany>

          <ContainerContactCompany>
              <TitleInfoCompany>Contato</TitleInfoCompany>

              <ContactCompany>
                <BiPhoneCall size={20} /> 
                <a href="tel:6536820700">{'(65) 3682-0700'}</a>
              </ContactCompany>

              <ContactCompany>
                <FaWhatsapp size={20} />
                <a href={whatsappHref} rel="noreferrer" target="_blank">(65) 3682-0700</a>
              </ContactCompany>
          </ContainerContactCompany>
        </InfoCompany>
        <FooterMapCard>
          <iframe
            title="Mapa da Extincenter"
            src="https://maps.google.com/maps?q=R.%20S%C3%A3o%20Bento,%2021%20-%20Centro%20Norte,%20V%C3%A1rzea%20Grande%20-%20MT&t=&z=15&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </FooterMapCard>
      <CopyRight>
        <span>© Copyright EXTINCENTER COMERCIO E RECARGA DE EXTINTORES LTDA - CNPJ: 03.551.500/0001-00</span>
      </CopyRight>
      </SectionFooter>
    </>

  );
}

export default App;
